
import modelBaseV2 from '../../models/model-base-v2.model';

const fileTemplateModel = {
  downloadExcelTemplate: (fileName, exportConfig) => {
    return modelBaseV2.postDownload("/api/executesp/export/commontemplateremark", { body: exportConfig }, fileName);
  },
}

export default fileTemplateModel



